import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { array, bool, func, node, oneOfType, shape, string } from 'prop-types';
import ModalAuthorization from '../ModalAuthorization';
import AuthorizationGroup from '../AuthorizationGroup';
import { checkSpecificError } from '../utils/backendErrors';

var Recovery = function Recovery(_ref) {
  var isDesktop = _ref.isDesktop,
      backTitle = _ref.backTitle,
      buttonDisabled = _ref.buttonDisabled,
      buttonText = _ref.buttonText,
      buttonTheme = _ref.buttonTheme,
      fields = _ref.fields,
      heading = _ref.heading,
      headingColor = _ref.headingColor,
      info = _ref.info,
      isModal = _ref.isModal,
      isOpen = _ref.isOpen,
      loginHref = _ref.loginHref,
      notification = _ref.notification,
      notificationTitle = _ref.notificationTitle,
      onBack = _ref.onBack,
      onButtonClick = _ref.onButtonClick,
      onClose = _ref.onClose,
      title = _ref.title,
      wrapFields = _ref.wrapFields,
      wrapHeading = _ref.wrapHeading,
      getTestId = _ref.getTestId,
      ticketConfirmed = _ref.ticketConfirmed,
      isSecretEntered = _ref.isSecretEntered,
      dictionary = _ref.dictionary;
  var banner = React.useMemo(function () {
    var currentNotification = notification;

    if (typeof currentNotification === 'string' && checkSpecificError(currentNotification)) {
      currentNotification = dictionary.t('com.recovery.password.notification.something_went_wrong');
    }

    return (notification || notificationTitle) && {
      children: currentNotification,
      title: notificationTitle,
      view: 'error'
    };
  }, [notification, notificationTitle]);
  var actions = React.useMemo(function () {
    return [_objectSpread({
      block: true,
      disabled: buttonDisabled,
      children: buttonText,
      onClick: onButtonClick,
      size: 'large',
      theme: buttonTheme,
      type: 'submit'
    }, getTestId(!ticketConfirmed && isSecretEntered ? 'submitNext' : 'submit'))];
  }, [buttonDisabled, buttonText, buttonTheme, onButtonClick]);
  var onLoginHref = React.useCallback(function () {
    if (typeof loginHref === 'function') {
      loginHref();
    } else {
      window.location.href = loginHref;
    }
  }, [loginHref]);
  return /*#__PURE__*/React.createElement(ModalAuthorization, {
    backTitle: backTitle,
    isDesktop: isDesktop,
    isModal: isModal,
    isOpen: isOpen,
    onBack: loginHref ? onLoginHref : onBack,
    onClose: onClose,
    title: title,
    titleSize: 3,
    wrapTitle: true,
    getTestId: getTestId
  }, /*#__PURE__*/React.createElement(AuthorizationGroup, {
    actions: actions,
    fields: fields,
    form: {
      onSubmit: onButtonClick
    },
    heading: heading,
    headingColor: headingColor,
    info: info,
    notification: banner,
    wrapFields: wrapFields,
    wrapHeading: wrapHeading,
    getTestId: getTestId
  }));
};

Recovery.propTypes = {
  isDesktop: bool,
  dictionary: shape({
    t: func
  }),
  backTitle: node,
  buttonDisabled: bool,
  buttonText: node,
  buttonTheme: string,
  fields: oneOfType([node, array]),
  heading: node,
  headingColor: string,
  info: node,
  isModal: bool,
  isOpen: bool,
  loginHref: oneOfType([string, func]),
  notification: node,
  notificationTitle: node,
  onBack: func,
  onButtonClick: func,
  onClose: func,
  title: node,
  wrapFields: bool,
  wrapHeading: bool,
  getTestId: func,
  ticketConfirmed: bool,
  isSecretEntered: bool
};
Recovery.defaultProps = {
  buttonDisabled: false,
  buttonTheme: 'b2c',
  isModal: true,
  isOpen: true,
  wrapFields: false
};
export default Recovery;